// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kit_wrapper__GZ2sY","title":"kit_title__NavBj"};